import type { PageFooterData } from '#/components/PageFooter/types/PageFooterData';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetInternshipsRoutePath } from '#/modules/search/routing/helpers/searchGetInternshipsRoutePath';
import { searchGetJobsRoutePath } from '#/modules/search/routing/helpers/searchGetJobsRoutePath';
import { searchGetOrgsRoutePath } from '#/modules/search/routing/helpers/searchGetOrgsRoutePath';
import { SIGN_UP_TO_POST_URL_FOR_LOCALE } from '#/routing/route-constants';
import { createOrgRoute, postAListingRoute } from '#/routing/routes';

export const pageFooterDataEn: PageFooterData = {
  idealistDays: {
    title: 'Idealist Days',
    links: [
      {
        type: 'our-vision',
        title: 'Our Vision',
        href: '/en/days/learn-more',
      },
      {
        type: 'spread-the-word',
        title: 'Invite a Friend',
        href: '/en/days/invite-a-friend',
      },
      {
        type: 'plan-ahead',
        title: 'Plan Ahead',
        href: '/en/days/planning',
      },
      {
        type: 'take-a-logo',
        title: 'Take a Logo',
        href: '/en/days/logos',
      },
      {
        type: 'support-our-work',
        title: 'Support Our Work',
        href: 'https://giving.classy.org/campaign/695322/donate',
      },
    ],
  },
  findAJob: {
    title: 'Find a Job',
    links: [
      {
        type: 'jobs',
        title: 'Jobs',
        href: searchGetJobsRoutePath({ locale: I18nLocale.EN }),
      },
      {
        type: 'internships',
        title: 'Internships',
        href: searchGetInternshipsRoutePath({ locale: I18nLocale.EN }),
      },
      {
        type: 'organizations',
        title: 'Organizations',
        href: searchGetOrgsRoutePath({ locale: I18nLocale.EN }),
      },
      {
        type: 'salary-explorer',
        title: 'Salary Explorer',
        href: '/nonprofit-salary-explorer',
      },
      {
        type: 'career-advice',
        title: 'Career Advice',
        href: '/en/careers',
      },
    ],
  },
  postOnIdealist: {
    title: 'Post on Idealist',
    links: [
      {
        type: 'post-a-listing',
        title: 'Post a listing',
        href: postAListingRoute.with({}),
      },
      {
        type: 'create-org',
        title: 'Add your Organization',
        href: createOrgRoute.with({}),
      },
      {
        type: 'employer-resources',
        title: 'Employer Resources',
        href: '/en/orgs/resources',
      },
      {
        type: 'for-grad-schools',
        title: 'For Grad Schools',
        href: '/grad-schools/exhibit',
      },
    ],
  },
  aboutUsNew: {
    title: 'About Us',
    links: [
      {
        type: 'our-story',
        title: 'Our Story',
        href: '/en/about',
      },
      {
        type: 'our-team',
        title: 'Our Team',
        href: '/en/about/our-team',
      },
      {
        type: 'our-partners',
        title: 'Our Partners',
        href: '/en/partners',
      },
      {
        type: 'data-insights',
        title: 'Data & Insights',
        href: '/en/insights',
      },
      {
        type: 'donate',
        title: 'Donate to Idealist',
        href: 'https://giving.classy.org/campaign/673245/donate',
      },
    ],
  },
  contactUs: {
    title: 'Contact Us',
    links: [
      {
        type: 'help-center',
        title: 'Help Desk',
        href: '/en/help',
      },
      {
        type: 'contact-us',
        title: 'Contact Idealist',
        href: '/en/about/contact',
      },
      {
        type: 'terms-of-service',
        title: 'Terms of Service',
        href: '/en/terms-of-service',
      },
      {
        type: 'privacy-policy',
        title: 'Privacy Policy',
        href: '/en/privacy-policy',
      },
      {
        type: 'site-map',
        title: 'Site Map',
        href: '/en/sitemap',
      },
    ],
  },
};

export const pageFooterUnauthDataEn: Partial<PageFooterData> = {
  postOnIdealist: {
    title: 'Post on Idealist',
    links: [
      {
        type: 'post-a-listing',
        title: 'Post a listing',
        href: SIGN_UP_TO_POST_URL_FOR_LOCALE.en,
      },
      {
        type: 'create-org',
        title: 'Add your Organization',
        href: SIGN_UP_TO_POST_URL_FOR_LOCALE.en,
      },
      {
        type: 'create-community-group',
        title: 'Add your Community Group',
        href: SIGN_UP_TO_POST_URL_FOR_LOCALE.en,
      },
    ],
  },
};
